export default __webpack_public_path__ + "static/media/servicios_adicionales.2c78e911.png";